import {onDestroy, onMount} from "svelte";

const selectors = ['select#currencies']

export default function useCurrencyConverter(callback: VoidFunction) {
    onMount(() => {
        selectors.forEach(selector => {
            document.querySelector(selector)?.addEventListener("change", callback);
        });
    });

    onDestroy(() => {
        selectors.forEach(selector => {
            document.querySelector(selector)?.removeEventListener("change", callback);
        });
    });
}